import React from 'react';
import { Box, CircularProgress, FormControl, MenuItem, Select } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { getOrderStatus, ORDER_STATUS_OPTIONS, normalizeOrderStatus } from './orderStatus';

const STATUS_COLORS = {
  awaiting_payment: '#c2185b',
  completed: '#2e7d32',
  in_production: '#7b1fa2',
  new: '#1565c0',
  processing: '#ed6c02',
  returned: '#212121'
};

const statusColor = (status) => STATUS_COLORS[status.value] || STATUS_COLORS.new;

function StatusDot({ color }) {
  return (
    <Box
      aria-hidden="true"
      component="span"
      sx={{ bgcolor: color, borderRadius: '50%', flex: '0 0 auto', height: 8, width: 8 }}
    />
  );
}

export default function OrderStatusSelect({ value, onChange, disabled = false, label = 'Статус' }) {
  const stopPropagation = (event) => event.stopPropagation();
  const status = getOrderStatus(value);

  return (
    <FormControl fullWidth size="small" onClick={stopPropagation} onKeyDown={stopPropagation}>
      <Select
        aria-label={label}
        SelectDisplayProps={{ 'aria-label': label }}
        value={normalizeOrderStatus(value)}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        renderValue={() => (
          <Box component="span" sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
            <StatusDot color={statusColor(status)} />
            {status.label}
          </Box>
        )}
        endAdornment={
          disabled ? (
            <CircularProgress size={16} sx={{ mr: 3.5 }} aria-label="Запазване на статус" />
          ) : null
        }
        sx={() => {
          const color = statusColor(status);

          return {
            bgcolor: alpha(color, 0.1),
            borderRadius: 999,
            color,
            fontWeight: 700,
            minWidth: 190,
            '& .MuiOutlinedInput-notchedOutline': { borderColor: alpha(color, 0.7) },
            '& .MuiSelect-icon': { color },
            '& .MuiSelect-select': { alignItems: 'center', display: 'flex', whiteSpace: 'normal' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: color
            }
          };
        }}
      >
        {ORDER_STATUS_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={() => {
              const color = statusColor(option);
              const selectedBackground = alpha(color, 0.12);

              return {
                alignItems: 'center',
                color,
                fontWeight: 650,
                gap: 1,
                whiteSpace: 'normal',
                '&.Mui-selected, &.Mui-selected:hover': { bgcolor: selectedBackground }
              };
            }}
          >
            <StatusDot color={statusColor(option)} />
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
